import classNames from "classnames";
import { Avatar, Card, CardHeader } from "@mui/material";

import useBoundStore from "store";
import styles from "./cardWithAvatar.module.scss";

export interface CardWithAvatarProps {
  children: React.ReactNode;
  className?: string;
  "data-testid"?: string;
  noHeaderGutterBottom?: boolean;
  icon: React.ReactNode;
  subheader?: string;
  title: string;
}

function CardWithAvatar(props: CardWithAvatarProps) {
  const {
    "data-testid": dataTestId,
    children,
    className,
    icon,
    noHeaderGutterBottom = false,
    subheader,
    title,
  } = props;
  const theme = useBoundStore((state) => state.generalSettings.theme);

  return (
    <Card data-testid={dataTestId} className={classNames(styles.card, className)}>
      <Avatar
        className={classNames(styles.avatar, {
          [styles.darkAvatar]: theme === "dark",
          [styles.lightAvatar]: theme === "light",
        })}
        variant='rounded'
      >
        {icon}
      </Avatar>
      <CardHeader
        className={classNames(styles.cardHeader, {
          [styles.noHeaderGutterBottom]: noHeaderGutterBottom,
        })}
        title={title}
        subheader={subheader}
      />

      {children}
    </Card>
  );
}

export default CardWithAvatar;
